module.exports = __webpack_public_path__ + "img/developer3.559b9f06.png";